import api from './api';

const getExecutiveStats = async (params = {}) => {
    try {
        const response = await api.get('/admin/executive-stats', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching executive stats:', error);
        throw error;
    }
};

const getAdvancedStats = async (params = {}) => {
    try {
        const response = await api.get('/admin/advanced-stats', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching advanced stats:', error);
        throw error;
    }
};

const getClusterCustomers = async (clusterType, dateRange = {}) => {
    try {
        const params = {};
        if (dateRange.startDate) params.startDate = dateRange.startDate;
        if (dateRange.endDate) params.endDate = dateRange.endDate;

        const response = await api.get(`/admin/cluster/${clusterType}/customers`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching cluster customers:', error);
        throw error;
    }
};

export default {
    getExecutiveStats,
    getAdvancedStats,
    getClusterCustomers
};
